<template>
  <div class="FormImageSelect">
    <Btn
      class="sm light selectImage"
      @click="doShowModal = true">
      {{ $t('selectImage') }}
    </Btn>
    <ModalImageSelect
      v-if="doShowModal"
      :article="article"
      :fileId="fileId"
      :isUploading.sync="isUploading"
      :section="section"
      :type="type"
      @close="doShowModal = false"
      @update:fileId="$up('fileId', $event)"
      @update:section="$up('section', $event)" />
    <div
      v-if="isUploading"
      class="loaderWrap">
      <Loader class="lg" />
    </div>
  </div>
</template>

<script>
import ModalImageSelect from './ModalImageSelect'

export default {
  components: {
    ModalImageSelect,
  },
  props: {
    article: Object,
    fileId: Number,
    section: Object,
    type: String,
  },
  data() {
    return {
      doShowModal: false,
      isUploading: false,
    }
  },
}
</script>

<style lang="scss">
.FormImageSelect {
  .Btn.selectImage {
    margin-top: 0.5rem;
  }
}
</style>

<i18n>
{
  "en": {
    "selectImage": "Select image"
  }
}
</i18n>
